<template>
  <v-container fluid>
    <PageHeading
      :text="$t('page-kiosk-devices.title')"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-kiosk-device-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Добавить киоск
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridKioskDevices ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeading from '@/components/page-heading'
import GridKioskDevices from './grid'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  components: {
    PageHeading,
    GridKioskDevices
  },
  mixins: [gridPageInterface],
  metaInfo () {
    return {
      title: 'Киоски'
    }
  }
}
</script>
